"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessingSpinner = void 0;
const react_1 = __importDefault(require("react"));
const processing_spinner_styles_1 = require("./processing-spinner.styles");
const icons_1 = require("../../../../icons");
const ProcessingSpinner = ({ className }) => (react_1.default.createElement(processing_spinner_styles_1.StyledIconSpinnerContainer, { className: className }, react_1.default.createElement(icons_1.ProcessingIcon, null)));
exports.ProcessingSpinner = ProcessingSpinner;
exports.default = exports.ProcessingSpinner;
